import {
  API_ENDPOINT,
  useClientApiV1UserDevicesIdRemoveCreateMutation,
} from '../../resources/@types/uccSchema';

interface UseClientV1UserDevicesIdRemoveMutation {
  id: number;
  options?: Parameters<typeof useClientApiV1UserDevicesIdRemoveCreateMutation>[0]['options'];
}

export function useUserDevicesIdRemoveCreateMutation({
  id,
  options,
}: UseClientV1UserDevicesIdRemoveMutation) {
  return useClientApiV1UserDevicesIdRemoveCreateMutation({
    url: API_ENDPOINT.CLIENT_V1_USER_DEVICES_ID_REMOVE(id.toString()),
    options,
  });
}
